<div class="tenants-info" >
    <h1>{{selected_property.shop_label}}</h1>
    <div class="data-loading" *ngIf="!floorDetail">
        <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'" [width]="'80px'"></app-skeleton-loader> :
         <ul>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'" [width]="'120px'"></app-skeleton-loader></li>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'" [width]="'120px'"></app-skeleton-loader></li>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'" [width]="'120px'"></app-skeleton-loader> </li>
        </ul>
    </div>
    <div class="floors" *ngIf="floorDetail">
        <h2>{{'reports.floor' | translate }} : </h2>
        <ul>
            <li *ngFor="let floor of floorDetail; index as i" (click)="setGeoLayer(i, null, true)" [ngClass]="{'active': selectedIndex == i, 'disabled_button' : selectedIndex == -1}">{{ floor.floor_name }} <span *ngIf="floor.unit_count && !selected_property?.is_property">{{floor.unit_count}}</span></li>
        </ul>

    </div>
    <div class="showperror" *ngIf="floorDetail && !currentFloorSelected?.unit_layout?.tenant_unit && !selected_property?.is_property">
        <span>{{'There is no' | translate}} "{{selected_property.shop_label}}" {{'on this floor' | translate }}</span>
    </div>
    <div class="floor-layers data-loading" *ngIf="!currentFloorSelected">
        <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'20px'" [width]="'180px'"></app-skeleton-loader>
        <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
            [height]="'20px'" [width]="'180px'"></app-skeleton-loader>
    </div>
    <div class="floor-layers" *ngIf="currentFloorSelected">
        <ul>
            <!-- / {{ currentFloorSelected.unit_layout?.filled_unit || 0  }} + {{ currentFloorSelected.unit_layout?.tenant_unit || 0 }}  -->
            <li class="filled">{{'reports.occupiedUnits' | translate}} ({{ (currentFloorSelected.unit_layout?.filled_unit || 0) + (currentFloorSelected.unit_layout?.tenant_unit || 0) }})</li>
            <li class="tenant direction" *ngIf="!selected_property?.is_unit_layout && currentFloorSelected.unit_layout.tenant_unit">{{selected_property.shop_label}} ({{ currentFloorSelected.unit_layout?.tenant_unit || 0 }})</li>
            <li class="tenant direction" *ngIf="selected_tenant && selected_tenant?.tenant_name && selected_tenant?.floor_uid == currentFloorSelected.floor_uid">{{selected_tenant.tenant_name}}</li>
            <li class="tenant direction" *ngIf="selected_property?.is_unit_layout  && selected_property?.floor_uid == currentFloorSelected.floor_uid">{{selected_property.tenant_name_unit_number}}</li>
            <li class="vacannt">{{'Vacant' | translate }} ({{ currentFloorSelected.unit_layout.vacant_unit || 0 }})</li>
        </ul>
    </div>
</div>
<div id="tenantsMap" #mapIdentifier [ngClass]="{'no-tenant': !currentFloorSelected?.unit_layout?.tenant_unit && !selected_property?.is_property}">
    
</div>
<app-spinner *ngIf="!floorDetail" [loderstate]="true"></app-spinner>

<!-- <ng-container  *ngIf="currentReportView === viewType.gridView || currentReportView === viewType.mapGridView">
<div class="mapLayer-panel">
    <app-map-property-details [propertyInfo]="selected_property"></app-map-property-details>
</div>   
</ng-container>  -->